import apiLogin from '../api/apiLogin.js'
import apiUser from '../api/apiUser.js'
import apiLocation from '../api/apiLocation.js'
import store from '../store/index.js'
import bus from '../common/bus.js'
import router from '../router/index.ts'
import locationDataOptimizer from '../utils/locationDataOptimizer.js'
import apiOptimizationConfig from '../config/apiOptimization.js'
import realtimeMonitorLocationBootstrap from '../utils/realtimeMonitorLocationBootstrap'

var userMap = new Map()
var trackerMap = new Map()
const { resetLocationBootstrapCache, resolveLocationRequestMode } =
  realtimeMonitorLocationBootstrap

var me = {
  callback: null,
  callbackMap: null,
  autoUpdatePaused: false,  // 控制自动更新是否暂停
  init: async function (that, callback) {
    // 监听批量命令对话框的暂停/恢复事件
    bus.$on('pauseAutoUpdate', () => {
      me.autoUpdatePaused = true
      console.log('✓ 自动更新已暂停（批量命令对话框打开）')
    })
    bus.$on('resumeAutoUpdate', () => {
      me.autoUpdatePaused = false
      console.log('✓ 自动更新已恢复（批量命令对话框关闭）')
    })
    // that.GLOBAL.countsUpdateLocation = 0;
    // that.GLOBAL.tUpdateLocation = setTimeout(function () {
    // 	that.$Tools.log(":userInfo",that.GLOBAL.userInfo)
    //     me.TimingUpdateLocation(that)
    //  }, 2000);
    if (that.GLOBAL.userInfo != null) {
      if (that.GLOBAL.userInfo.users != undefined) {
        that.$Tools.log('数据已完善:userInfo', that.GLOBAL.userInfo)
      } else {
        that.$Tools.log('不重新登陆 获取子账号信息', that.GLOBAL.userInfo)
        me.startGetUsers(that)
      }
      // 加载命令权限
      me.loadCommandPermission()
      callback(true)
    } else {
      that.$Tools.log('没有登陆直接访问的，需要重新登陆')
      var parm = {
        language: localStorage.getItem('language'),
        timezone: parseInt(localStorage.getItem('timezone')),
        useraccount: localStorage.getItem('useraccount'),
        password: localStorage.getItem('password'),
      }
      // formData格式转换
      var formData = new FormData()
      formData.append('language', parm.language)
      formData.append('timezone', parm.timezone)
      formData.append('useraccount', parm.useraccount)
      formData.append('password', parm.password)

      if (parm.useraccount != '' && parm.password != '') {
        return await apiLogin.possLogin(formData).then((msg) => {
          if (msg.state == true) {
            //that.$message.success('登录成功');
            localStorage.setItem('ms_token', msg.value.userToken)
            localStorage.setItem('useraccount', parm.useraccount)
            localStorage.setItem('password', parm.password)
            that.GLOBAL.userInfo = msg.value
            that.$Tools.log('登陆后获取子账号信息')
            me.startGetUsers(that)
            // 登录后强制刷新命令权限
            me.loadCommandPermission(true)
            callback(true)
          } else {
            callback(false)
          }
        })
      } else {
        callback(false)
      }
    }
  },

  // 加载命令权限（force: 是否强制刷新，默认 false 使用缓存）
  loadCommandPermission: function (force = false) {
    store.dispatch('permission/LoadCommandPermission', { force })
  },

  async startGetUsers(that) {
    resetLocationBootstrapCache({ trackerMap, userMap })
    that.GLOBAL.trackerMap = new Map()

    var count = 0
    userMap.set(that.GLOBAL.userInfo.sssid, that.GLOBAL.userInfo)
    me.getuser(that, that.GLOBAL.userInfo.sssid, function () {
      that.$Tools.log(
        '账号获取完了:',
        new Date(),
        that.GLOBAL.userInfo.nickName,
        that.GLOBAL.userInfo.sssid,
        that.GLOBAL.userInfo
      )
      that.GLOBAL.countsUpdateLocation = 0
      that.GLOBAL.tUpdateLocation = setTimeout(function () {
        if (!me.TimingUpdateRoute()) {
          me.getAllLastLocationsSpc(that)
        }
        me.TimingUpdateLocation(that)
      }, 100)
    })

    // a.then((res) => {

    // 	that.$Tools.log("账号获取完了:",res,new Date(),that.GLOBAL.userInfo.nickName,that.GLOBAL.userInfo.sssid,that.GLOBAL.userInfo)

    // })
  },

  exitLogin: function (that) {
    // 清除定时器，避免退出后继续请求
    if (that.GLOBAL && that.GLOBAL.tUpdateLocation) {
      clearTimeout(that.GLOBAL.tUpdateLocation)
      that.GLOBAL.tUpdateLocation = null
    }

    resetLocationBootstrapCache({ trackerMap, userMap })
    if (that.GLOBAL) {
      that.GLOBAL.trackerMap = new Map()
    }

    localStorage.setItem('ms_token', '')
    localStorage.setItem('password', '')

    that.$router.push('/loginPage')
  },

  getuser: async function (that, sAccount, callback) {
    var info = userMap.get(sAccount)
    var parm = {
      sAccouont: sAccount,
    }

    //admin获取所有未授权或授权tracker
    // if (that.GLOBAL.userInfo.account == "admin") {
    //     parm.access = "";
    // }

    return await apiUser.GetSimpleUser(parm).then((res) => {
      if (res.state == true) {
        info.trackers = res.value.trackers
        info.users = res.value.users
        bus.$emit('updateUserInfo', info)
        callback(true)
        // if (info.users.length == 0) {
        // 	//that.$Tools.log("该账号没有子账号了",new Date,info.nickName,info.sssid)
        // 	callback(true)
        // } else {
        // 	var count = 0;
        // 	for (let i = 0; i < info.users.length; i++) {
        // 		userMap.set(info.users[i].sssid, info.users[i])
        // 		me.getuser(that, info.users[i].sssid, function () {
        // 			count++;
        // 			if (count == info.users.length) {
        // 				//that.$Tools.log("该账号的子账号获取完了",new Date,info.nickName,info.sssid)
        // 				callback(true)
        // 			}
        // 		})
        // 	}
        // }
      }
    })
    // return await apiUser.GetSubUsersTrackers(parm).then(res => {
    // 	if (res.state == true) {
    // 		info.trackers = res.value.trackers
    // 		info.users = res.value.users
    // 		if (info.users.length == 0) {
    // 			//that.$Tools.log("该账号没有子账号了",new Date,info.nickName,info.sssid)
    // 			callback(true)
    // 		} else {
    // 			var count = 0;
    // 			for (let i = 0; i < info.users.length; i++) {
    // 				userMap.set(info.users[i].sssid, info.users[i])
    // 				me.getuser(that, info.users[i].sssid, function () {
    // 					count++;
    // 					if (count == info.users.length) {
    // 						//that.$Tools.log("该账号的子账号获取完了",new Date,info.nickName,info.sssid)
    // 						callback(true)
    // 					}
    // 				})
    // 			}
    // 		}
    // 	}
    // })
  },

  TimingUpdateRoute: function () {
    if (
      router.currentRoute.path === '/loginPage' ||
      router.currentRoute.path === '/realTimeMonitor' ||
      router.currentRoute.path === '/videoMonitor' ||
      router.currentRoute.path === '/trackPlayback' ||
      router.currentRoute.path === '/videoPlayback' ||
      router.currentRoute.path === '/playback' ||
      router.currentRoute.path === '/statisticalReport' ||
      router.currentRoute.path === '/infoManagement' ||
      router.currentRoute.path === '/ruleManagement'
    ) {
      return true
    } else {
      return false
    }
  },

  TimingUpdateLocation: function (that) {
    clearTimeout(that.GLOBAL.tUpdateLocation) //清除定时器
    //that.$Tools.log("倒计时：",that.GLOBAL.countsUpdateLocation,new Date())
    if (that.GLOBAL.countsUpdateLocation <= 0) {
      if (this.TimingUpdateRoute()) {
        this.getAllLastLocationsSpc(that)
      }

      let data = store.getters.realtimeSettingData || store.getters.realtimeSettingDefaultData
      const time = data.dataRefreshTimeSelected
      that.GLOBAL.countsUpdateLocation = time - 1
      console.log(time)
      that.GLOBAL.tUpdateLocation = setTimeout(function () {
        me.TimingUpdateLocation(that)
      }, 1000)
      // apiLocation.GetAllLastLocations().then(res => {
      // 	if (res.state == true) {
      // 		for (let i = 0; i < res.value.length; i++) {
      // 			let tarcks = res.value[i];
      // 			if (tarcks.tracker != undefined) {
      // 				trackerMap.set(tarcks.tracker.sssid, tarcks);
      // 			}
      // 		}
      // 		that.GLOBAL.trackerMap = trackerMap
      // 		that.$Tools.log("设备位置信息：", that.GLOBAL.trackerMap);
      // 		if (me.callback != null) {
      // 			me.callback(that.GLOBAL.userInfo);
      // 		}
      // 		if (me.callbackMap != null) {
      // 			me.callbackMap(trackerMap);
      // 		}
      // 	}

      // 	that.GLOBAL.countsUpdateLocation = 10;
      // 	that.GLOBAL.tUpdateLocation = setTimeout(function () {
      // 		me.TimingUpdateLocation(that);
      // 	}, 2000);
      // })
    } else {
      that.GLOBAL.countsUpdateLocation--
      that.GLOBAL.tUpdateLocation = setTimeout(function () {
        me.TimingUpdateLocation(that)
      }, 1000)
    }
  },

  getAllLastLocationsSpc(that, myCallback, options = {}) {
    // 如果自动更新被暂停，则不执行GetAllLastLocations
    if (me.autoUpdatePaused) {
      console.log('⏸ 自动更新被暂停，跳过本次GetAllLastLocations调用')
      return
    }

    let data = store.getters.generalSettingData || store.getters.generalSettingDefaultData

    const { isFirstLoad, onlyOnline } = resolveLocationRequestMode({
      trackerMapSize: trackerMap.size,
      overrideOnlyOnline: options.onlyOnline,
    })

    // 基础参数
    var p = {
      onlinePlanPar: {
        type: data.VehicleOnline.onlineType,
        onlineType: data.VehicleOnline.onlineType,
        onlineInterval: data.VehicleOnline.onlineTime,
        isOfflineWhenSleep: data.VehicleOnline.sleepOffline,
        positioningSpeedOffline: data.VehicleOnline.positioningSpeedOffline,
        offlineSpeedCondition: data.VehicleOnline.positioningSpeedBetween.km,
        offlineTimeCondition: data.VehicleOnline.positioningSpeedBetween.min,
      },
      vehicleParkingPar: {
        isEnable: data.VehicleStop.positioningSpeed,
        speed: data.VehicleStop.km,
      },
      // 新增优化参数
      // 首次加载获取所有设备（包括离线），后续只获取在线设备（除非明确指定）
      onlyOnline,
      compress: true,    // 启用数据压缩
      fields: options.fields || [  // 默认字段列表，可通过 options 覆盖
        // tracker 必需字段
        'tracker.sssid',
        'tracker.name',
        'tracker.imei',
        'tracker.typeName',
        'tracker.objectTypeId',
        'tracker.protocol',
        'tracker.color',
        'tracker.icon',
        'tracker.image',
        'tracker.locked',
        'tracker.carNumber',
        'obdData',
        // lastLoc 必需字段
        'lastLoc.latitude',
        'lastLoc.longitude',
        'lastLoc.speed',
        'lastLoc.direction',
        'lastLoc.address',
        'lastLoc.gpsAvailable',
        'lastLoc.gsmLatitude',
        'lastLoc.gsmLongitude',
        'lastLoc.stationID',
        'lastLoc.online',
        'lastLoc.receivedTime',
        'lastLoc.battery',
        'lastLoc.gsmsignal',
        'lastLoc.eventId',
        'lastLoc.eventName',

        // 报警信息
        'lastAlarm'
      ]
    }

    // 根据不同页面可能需要不同的字段
    const currentRoute = router.currentRoute.path
    if (currentRoute === '/realTimeMonitor' || currentRoute === '/videoMonitor') {
      // 实时监控和视频监控页面需要更多字段
      if (!options.fields) {
        p.fields.push('lastLoc.keyValues', 'lastLoc.journeyStr', 'lastLoc.wifi', 'lastLoc.ble')
      }
    }

    console.log('GetAllLastLocations 请求参数优化：', {
      isFirstLoad,
      onlyOnline: p.onlyOnline,
      fieldCount: p.fields.length,
      compress: p.compress,
      totalTrackers: trackerMap.size
    })

    localStorage.setItem('onlinePar', JSON.stringify(p))

    apiLocation.GetAllLastLocations(p).then((res) => {
      if (res.state == true) {
        let totalDevices = 0
        let onlineCount = 0
        let alarmCount = 0
        let longOfflineCount = 0

        // 获取长时间离线设置
        const isLongOfflineEnabled = data.VehicleOnline?.longOfflineTimeEnable || false
        const longOfflineTime = data.VehicleOnline?.longOfflineTime || 1440 // 默认1440分钟(24小时)
        const currentTime = new Date()
        const cutoffTime = new Date(currentTime.getTime() - longOfflineTime * 60 * 1000) // longOfflineTime是分钟

        for (let i = 0; i < res.value.length; i++) {
          let tarcks = res.value[i]
          if (tarcks.tracker != undefined) {
            totalDevices++
            trackerMap.set(tarcks.tracker.sssid, tarcks)

            if (tarcks.lastLoc && tarcks.lastLoc.online === true) {
              onlineCount++
            }

            if (tarcks.lastAlarm !== null) {
              alarmCount++
            }

            // 计算长时间离线设备
            if (isLongOfflineEnabled && tarcks.lastLoc && tarcks.lastLoc.receivedTime) {
              try {
                const deviceLastTime = new Date(tarcks.lastLoc.receivedTime)
                if (deviceLastTime < cutoffTime) {
                  longOfflineCount++
                }
              } catch (error) {
                console.warn('Invalid r_datetime format:', tarcks.lastLoc.receivedTime)
              }
            }
          }
        }

        console.log('Updating statistics:', {
          totalDevices,
          onlineDevices: onlineCount,
          alarmDevices: alarmCount,
          longOfflineDevices: longOfflineCount,
          longOfflineEnabled: isLongOfflineEnabled,
          longOfflineTimeMinutes: longOfflineTime,
        })

        // 更新 Vuex store
        store.dispatch('settings/updateDeviceStatistics', {
          totalDevices,
          onlineDevices: onlineCount,
          alarmDevices: alarmCount,
          longOfflineDevices: longOfflineCount,
        })

        that.GLOBAL.trackerMap = trackerMap
        if (me.callback != null) {
          me.callback(that.GLOBAL.userInfo)
        }
        if (me.callbackMap != null) {
          me.callbackMap(trackerMap)
        }

        bus.$emit('updateAllLocation', that.GLOBAL.userInfo)
      }
      if (myCallback) {
        myCallback()
      }
    })
  },
}
export default me
